import * as R from 'ramda'
import find from 'lodash/fp/find'
import matches from 'lodash/fp/matches'

export function get_status_label(value) {
    return R.compose(

        // Wenn kein `label` vorhanden, Default-Wert nutzen
        R.defaultTo('Unbekannter Status'),

        // `label`-Property des Status lesen
        R.prop('label'),

        // Status suchen
        find_status_by_value

    )(value)
}

export function get_status_value_by_value(value) {
    return R.compose(

        // ggf. Default-Wert setzen
        R.defaultTo('OPEN'),

        // erstes Match zurueckgeben
        R.head,

        // Durchschnitt mit gueltigen Werten erstellen
        R.intersection(['ALL', 'OPEN', 'IN_PROCESS', 'OFFERS_AVAILABLE', 'OFFER_CONFIRMED', 'IN_PRINT', 'DELIVERED', 'QA', 'COMPLETED', 'CANCELED', 'EXPIRED']),

        // Array aus Wert `value` erstellen
        Array,

        // ´value` uppercasen
        R.toUpper,

        // ggf. Default-Wert setzen
        R.defaultTo('')

    )(value)
}

export function get_printing_data_status_label(status) {
    return R.cond([
        [R.equals('WAITING_FOR_DATA'),       R.always('Warten auf Daten')],
        [R.equals('IN_REVIEW'),              R.always('Erst-/Zweitprüfung')],
        [R.equals('WAITING_FOR_FORM_PROOF'), R.always('Warten auf Freigabe-PDF')],
        [R.equals('FORM_PROOF_CONFIRMED'),   R.always('Freigabe-PDF bestätigt')],
        [R.equals('IN_PRINT'),               R.always('Im Druck')],
        [R.equals('QA'),                     R.always('Qualitätssicherung')],
        [R.equals('COMPLETED'),              R.always('Abgeschlossen')],
        [R.T,                                R.always('Unbekannter Status')]
    ])(status)
}

export function find_status_by_value(value) {
    const statuses = [
        { value: 'OPEN', label: 'Eingestellt' },
        { value: 'IN_PROCESS', label: 'In Bearbeitung' },
        { value: 'OFFERS_AVAILABLE', label: 'Angebote liegen vor' },
        { value: 'OFFER_CONFIRMED', label: 'Angebot wurde akzeptiert' },
        { value: 'IN_PRINT', label: 'Im Druck' },
        { value: 'PRODUCTION_RELEASE', label: 'Produktionsfreigabe erteilt' },
        { value: 'IN_PRODUCTION', label: 'In Produktion' },
        { value: 'QA', label: 'Qualitätssicherung' },
        { value: 'DELIVERED', label: 'Ausgeliefert' },
        { value: 'COMPLETED', label: 'Abgeschlossen' },
        { value: 'CANCELED', label: 'Storniert' },
        { value: 'EXPIRED', label: 'Preise abgelaufen' },
        { value: 'ALL', label: 'Alle' }
    ]

    return R.compose(

        // Status suchen
        find(matches({ value }))

    )(statuses)

}
